import fastfood from "./images/fastfood.jpg";
import React from "react";
import { GiChickenLeg } from "react-icons/gi";
import { FaPizzaSlice } from "react-icons/fa";
import { GiCarrot } from "react-icons/gi";
import { FcShop } from "react-icons/fc";
import pizza from "./images/pizza.jpg";
import mainPizza from "./images/pizza-hero.webp";
import mainFastfood from "./images/ajjemen.jpg";
import vegan from "./images/Vegan-Buddha-bowl.jpg";
import supermarket from "./images/supermarket.jpg";

export const restaurants = [
  {
    id: 1001,
    name: "Fast Food Paje",
    menu: ["prod_NXELwjdM2r53A4", "prod_L1vOoZdOLWlRa8"],
    location: "Paje",
    image: fastfood,
    mainImage: mainFastfood,
    icon: <GiChickenLeg />,
    deliverfee: 0,
    category: ["Fast Food", "Sausage", "Chicken"],
    query: [
      "fast food",
      "fastfood",
      "sausage",
      "chips",
      "french fries",
      "chicken",
      "beef",
      "michkaki",
      "meat",
      "potator chips",
      "potato",
      "barbeque",
      "bbq",
      "grilled",
    ],

    number: "+255 000 000",
    type: "Fast Food",
    email: "mzeemm1982@gmail.com",
    open: 10,
    close: 1,
  },
  {
    id: 1002,
    name: "Pizza Delight",
    type: "Pizza / Italian",
    deliverfee: 2.5,
    icon: <FaPizzaSlice />,
    menu: ["prod_mOVKl4GAKN5prR", "prod_gvRjwOVO2Zl4mN", "prod_31q0o3e0VBlDdj"],
    location: "Paje",
    category: ["Pizza", "Vegan", "Chicken", "Pasta", "Veg", "Burgers", "BBQ"],
    image: pizza,
    mainImage: mainPizza,
    featured: false,
    query: [
      "pizza",
      "pizza margherita",
      "chicken pizza",
      "salami pizza",
      "cheeseburger",
      "hamburger",
      "chicken burger",
    ],
    number: "+255 000 000",
    open: 11,
    close: 23,
    email: "louiealsaffar@gmail.com",
  },
  {
    id: 1003,
    name: "Mr Bowl",
    type: "Veg / Vegan",
    deliverfee: 2.5,
    icon: <GiCarrot />,
    menu: ["prod_7ZAMo1LEWxwNJ4"],
    location: "Paje",
    address: "test adress 1",
    zip: "",
    category: ["Veg", "Vegan", "Bowl"],
    image: vegan,
    mainImage: vegan,
    featured: false,
    query: ["vegan", "veg", "vegetarian", "bowl"],
    number: "+255 000 000",
    open: 11,
    close: 23,
    loid: "auth0|6123a867b540dd006b2d2a2b",
    active: true,
    days: "All",
    offer: "10%",
    offerdate: "30",
    email: "louiestokk@gmail.com",
  },
  {
    id: 1004,
    name: "Supermarket",
    type: "Supermarket",
    deliverfee: 2.5,
    icon: <FcShop />,
    menu: [
      "prod_A12JwrBzgvwPjn",
      "prod_VPvL5zY9mGoAQk",
      "prod_nPEVlN9q605a7d",
      "prod_9BAmwJrD1QweXd",
      "prod_mOVKl4GxQM5prR",
      "prod_ZM8X5nL6G3wpv4",
    ],
    location: "Paje",
    address: "test adress 1",
    zip: "",
    category: ["Supermarket"],
    image: supermarket,
    mainImage: supermarket,
    featured: true,
    query: ["shop", "market", "supermarket"],
    number: "+255 000 000",
    open: 9,
    close: 0,
    loid: "",
    active: true,
    days: "All",
    offer: "",
    offerdate: "",
    email: "",
  },
];
export const newRoute = [
  {
    name: "Tumba gymanisum kök",
    address: "Utbildningsvägen 2",
    city: "Tumba",
    routeId: "h3h3h3h3h3h",
    customerId: "2b2b2b-2b2b2b2",
    customerOrderNumber: "3333, 3333, 3333",
    coords: { lat: 57.7072326, lng: 11.9670171 },
    orders: [
      {
        name: "order 1",
        x: 11.901739,
        y: 57.773897,
        address: "Hisingsgatan 10",
        city: "Hisingen",
      },
      {
        name: "order 2",
        x: 11.916667,
        y: 57.9,
        address: "Olserödsgatan 29",
        city: "Kungälv",
      },
    ],
  },
  {
    name: "Tunaskolan hemkunskap",
    address: "Prästgårdsvägen 114",
    city: "Tumba",
    routeId: "h4h4h4h4h4h",
    customerId: "3b3b3b3b-3b3bb33b",
    customerOrderNumber: "2222, 2222, 2222",
    coords: { lat: 57.7072326, lng: 11.9670171 },
    orders: [
      {
        name: "order 3",
        x: 12.083333,
        y: 57.616667,
        address: "Testvägen 3",
        city: "Test city 3",
      },
      {
        name: "order 4",
        x: 12.166667,
        y: 57.466667,
        address: "Testvägen 4",
        city: "test city 4",
      },
    ],
  },
];
